/**
 * Central place for chain addresses.
 *
 * NOTE: In the web app (Vite), env vars must be prefixed with `VITE_` to be available at runtime.
 * Configure `VITE_WALLET_ADDR` in your deploy environment to point to the pool/hot wallet address.
 * Configure `VITE_USDC_ADDRESS` to override the default Base-native USDC contract address.
 */
// Default to production pool/hot wallet address if VITE_WALLET_ADDR is not set.
export const DEFAULT_WALLET_ADDR = '0xe833e7964928E497b25CC0FaAA39aB7216501FF8';

// Base-native USDC contract address. Configurable via VITE_USDC_ADDRESS.
// Default: 0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913
export const USDC_ADDRESS = (import.meta.env.VITE_USDC_ADDRESS as string | undefined)?.trim()
  || '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913';

export function getWalletRecipientAddress(): string {
  // Prefer build-time configured address; fall back to existing hardcoded dev value.
  const addr = (import.meta.env.VITE_WALLET_ADDR as string | undefined)?.trim();
  return addr && addr.length > 0 ? addr : DEFAULT_WALLET_ADDR;
}


